import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import { createAccountApi } from './index';
import type { AccountApi } from './client';

/**
 * Mounted only inside the account tree. A cluster screen that reached for
 * `useAccountApi()` would find no provider above it and throw on the spot
 * rather than quietly talking to the wrong console.
 */
const AccountApiContext = createContext<AccountApi | null>(null);

export function AccountApiProvider({
  children,
  client,
}: {
  children: ReactNode;
  client?: AccountApi;
}) {
  const value = useMemo(() => client ?? createAccountApi(), [client]);
  return <AccountApiContext value={value}>{children}</AccountApiContext>;
}

export function useAccountApi(): AccountApi {
  const value = useContext(AccountApiContext);
  if (value === null) {
    throw new Error('useAccountApi() used outside <AccountApiProvider>');
  }
  return value;
}
